// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.number.is-integer.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.number.is-integer.js
// module chunks = 0